/* ═══════════════════════════════════════════════════════
   iwobbl — Global Interactions
   Scroll reveal, navbar transparency, mega menu
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  /* ── Scroll Reveal ── */
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('v');
        }
      });
    },
    { threshold: 0.1 }
  );
  document.querySelectorAll('.rv').forEach((el) => revealObserver.observe(el));

  // Re-observe after Shopify section rendering (theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('.rv:not(.v)').forEach((el) => revealObserver.observe(el));
    });
  }

  /* ── Navbar & Mega Menu: handled by inline script in iwobbl-header.liquid ── */

  /* ── Series Dots Navigation ── */
  const seriesTrack = document.getElementById('iwobbl-series-track');
  const seriesDots = document.getElementById('iwobbl-series-dots');
  if (seriesTrack && seriesDots) {
    const dots = seriesDots.querySelectorAll('.s-dot');
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const cards = seriesTrack.children;
        if (cards[i]) {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          dots.forEach((d) => d.classList.remove('on'));
          dot.classList.add('on');
        }
      });
    });
  }

  /* ── Collection View Switcher ── */
  const viewBtns = document.querySelectorAll('.col-view-btn');
  const colGrid = document.getElementById('col-grid');
  if (viewBtns.length && colGrid) {
    viewBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        viewBtns.forEach((b) => b.classList.toggle('on', b.dataset.view === view));
        colGrid.className = 'col-grid ' + view;
      });
    });
  }
});
